/* eslint-disable no-unused-vars */
import { axios } from './index'

const resource = '/v1/stay'
const resource_fr = '/v1/stay/fellowtravelers'
const resource_pub = '/v1/stay/publicstay'


export default {
  async getOrderAcptDtlNo() {
    return axios
      .get(`${resource}/order/acceptance-detail-number`)
      .then((response) => response.data)
  },
  async getCanclePolicy(acptNo) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/order/cancel-policy/${acptNo}`).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async getOrderPulbicStayParam(menuNo) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/menu/${menuNo}/orders/public-inn/stay-param`).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async orderLowPrice(data) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order/low-price`, data).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  async sendAddingUserEmail(acptNo, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order/${acptNo}/companion-info`, data).then(
        (res) => {
          resolve(res)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  async sendAddingUserSubsidyEmail(acptNo, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order/${acptNo}/companion-info/fellowTravelers`, data).then(
        (res) => {
          resolve(res)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  async getPublicStayGuide(acptNo, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order/${acptNo}/public-stay/guide`, data).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async getOrderInfoPublicStay(acptNo) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/order/${acptNo}/public-stay`).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  async checkOrderTour(data) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/dp/order`, data).then(
        (response) => {
          resolve(response)
          // const data = {
          //   'status': 200
          // }
          // resolve(data.status)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  async createOrderPulbicStay(data) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order/public-stay`, data).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  getOrderHistory(params) {
    return new Promise((resolve, reject) => {
      axios.get(
        `${resource}/order/order-list`,
        { params: params }
      ).then(
        (res) => {
          resolve(res.data);
        },
        (error) => {
          reject(error?.error);
        }
      );
    });
  },

  getCafeInfo(reqParam) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/order/cafe/info`, {
        params: {
          catLrgClassCd: reqParam.catLrgClassCd,
          catMidClassCd: reqParam.catMidClassCd,
          catSmlClassCd: reqParam.catSmlClassCd,
          menuNo: reqParam.menuNo,
          planId: reqParam.planId,
          receivableFlag: reqParam.receivableFlag,
          ticketExclusionFlag: reqParam.ticketExclusionFlag,
          buppanExclusionFlag: reqParam.buppanExclusionFlag,
          famiExclusionFlag: reqParam.famiExclusionFlag,
          totalPrice: reqParam.totalPrice,
          useDate: reqParam.useDate,
          dayCount: reqParam.dayCount
        }
    }).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    });
  },
  checkCafeInfo(params) {
    return axios.post(`${resource}/order/cafe/check`, params);
  },
  // CRM独自対応 ↓↓↓
  putProfile() {
    return axios.put(`${resource}/profile/me`);
  },
  getProfile() {
    return axios.get(`${resource}/profile/me`);
  },
  // CRM独自対応 ↑↑↑
  async getEmailUrl(acptNo,companionEntryId) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource_fr}/companionOrder/${acptNo}/${companionEntryId}`).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async sendMailToPublicStay(params) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource_pub}/companionOrder/sendEmail`, params).then(
        (res) => {
          resolve(res)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  async sendMailToCopanionSubsidy(params) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource_fr}/companionOrder/sendEmail`, params).then(
        (res) => {
          resolve(res)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  async orderInput(params) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order/order_input`, params).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        })
    })
  },
  async selectPay(params) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order/confirm/select_pay`, params).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        })
    })
  },
  async orderPay(reserveId, data) {
    const headers = {
      reserveId
    }
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order/order_pay`, data, {headers}).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        })
    })
  },
}
